export { default as ProductsBrandsFilterBadge } from './ProductsBrandsFilterBadge';
